var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-autocomplete"},[_c('v-select',{staticClass:"bax-input-control bax-autocomplete",attrs:{"options":_vm.options,"value":_vm.value,"placeholder":_vm.placeholder,"label":_vm.label},on:{"input":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }